export type InteractionMode = "multiple_choice" | "role_play" | "conversational";

export const DEFAULT_MCQ_INSTRUCTIONS = `- Ask each question one at a time, reading it out loud verbatim before waiting for the learner's answer. Do not skip a question without reading it.
- Treat the listed valid answers as the only correct items. The learner passes a question when they produce at least the required minimum number of distinct items from that list (synonyms and obvious paraphrases are fine).
- After each answer, briefly confirm whether they passed or not and explain why. Do NOT reveal the overall score or a running tally during the session. If asked, reply that the full results will be shown right after the session ends.`;

export const INTERACTION_MODES: {
  id: InteractionMode;
  label: string;
  description: string;
  textareaLabel: string;
  textareaPlaceholder: string;
  generateLabel: string;
  showPersona: boolean;
  showInstructions: boolean;
}[] = [
  {
    id: "conversational",
    label: "Conversational",
    description: "Open conversation built on your content, for training, ask-me-anything, sales and more.",
    textareaLabel: "Knowledge",
    textareaPlaceholder: "Extracted knowledge will appear here. You can edit it freely.",
    generateLabel: "Generate knowledge",
    showPersona: true,
    showInstructions: true,
  },
  {
    id: "multiple_choice",
    label: "Open questions",
    description: "Assess the learner's knowledge: the avatar asks open questions and scores their performance.",
    textareaLabel: "Questions",
    textareaPlaceholder: "Generated questions will appear here. You can edit them before saving.",
    generateLabel: "Generate questions",
    showPersona: true,
    showInstructions: true,
  },
  {
    id: "role_play",
    label: "Role-play",
    description: "Assess the learner's knowledge and skills: they play out a scenario with the avatar, who scores their performance.",
    textareaLabel: "Scenarios",
    textareaPlaceholder: "Generated scenario and role descriptions will appear here.",
    generateLabel: "Generate role play",
    showPersona: false,
    showInstructions: true,
  },
];

export function getMode(id: InteractionMode | undefined) {
  return INTERACTION_MODES.find((m) => m.id === id) ?? INTERACTION_MODES[2];
}

/**
 * Modes whose sessions are scored by the Powtoon BE scoring job. Both
 * questionnaire (`multiple_choice`) and role-play sessions post the saved
 * transcript to the same endpoint; the backend resolves the questionnaire /
 * role-play artifact for the project itself.
 */
export function isScoredInteractionMode(
  mode: InteractionMode | undefined | null,
): boolean {
  return mode === "multiple_choice" || mode === "role_play";
}
